import Alpine from "alpinejs";
import masonry from "alpinejs-masonry";

Alpine.plugin(masonry);
